import { FilingStatus } from '@taxfyle/txf-api-client'

export const FILING_STATUSES_MAP: Record<FilingStatus, string> = {
  [FilingStatus.Single]: 'Single',
  [FilingStatus.MarriedFilingJointly]: 'Married Filing Jointly',
  [FilingStatus.MarriedFilingSeparately]: 'Married Filing Separately',
  [FilingStatus.HeadOfHousehold]: 'Head of Household',
  [FilingStatus.QualifiedSurvivingSpouse]: 'Qualified Surviving Spouse',
} as const

export const FILING_STATUSES = Object.entries(FILING_STATUSES_MAP) as [
  code: FilingStatus,
  label: string,
][]
